import { render } from "./FoerdermittelModalAnpassen.pug?vue&type=template&id=f4369160&lang=pug"
import script from "./FoerdermittelModalAnpassen.js?vue&type=script&lang=js"
export * from "./FoerdermittelModalAnpassen.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__